import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

export interface BroadCastAction {
  type: string;
  payload?: any;
}

@Injectable()
export class BroadcastService {
  private broadcastChannel?: BroadcastChannel;

  constructor() {
    try {
      this.broadcastChannel = new BroadcastChannel('rewards_dashboard_channel');
    } catch (error) {
      // This runs at app startup, so an unguarded throw would blank the whole
      // app. Without a channel the `?.` calls below just do nothing, so we only
      // lose cross-tab sync. Log and report it so the failure is never silent.
      console.error('Broadcast initial error', error);
      Sentry.captureException(error);
    }
  }

  postMessage<T extends BroadCastAction>(event: T): void {
    this.broadcastChannel?.postMessage(event);
  }

  registerMessageHandler<T extends BroadCastAction>(
    callback: (data: T) => void,
  ): void {
    this.broadcastChannel?.addEventListener(
      'message',
      (event: MessageEvent<T>) => callback(event.data),
    );
  }
}
